"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MarketplaceOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_MarketplaceOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2c.551 0 1 .449 1 1v2.5c0 .551-.449 1-1 1h-2.5c-.552 0-1-.449-1-1V3c0-.551.448-1 1-1H13ZM5.5 2c.551 0 1 .449 1 1v2.5c0 .551-.449 1-1 1H3c-.551 0-1-.449-1-1V3c0-.551.449-1 1-1h2.5ZM13 9.5c.551 0 1 .448 1 1V13c0 .55-.449 1-1 1h-2.5c-.551 0-1-.45-1-1v-2.5c0-.552.449-1 1-1H13Zm-7.5 0c.551 0 1 .449 1 1V13c0 .551-.449 1-1 1H3c-.551 0-1-.449-1-1v-2.5c0-.551.449-1 1-1h2.5ZM13 1h-2.5a2 2 0 0 0-2 2v2.5a2 2 0 0 0 2 2H13a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2ZM5.5 1H3a2 2 0 0 0-2 2v2.5a2 2 0 0 0 2 2h2.5a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2ZM13 8.5h-2.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2H13a2 2 0 0 0 2-2v-2.5a2 2 0 0 0-2-2Zm-7.5 0H3a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2h2.5a2 2 0 0 0 2-2v-2.5a2 2 0 0 0-2-2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_MarketplaceOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = MarketplaceOutline;
exports["default"] = _default;